import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-badd8462")

_pushScopeId("data-v-badd8462")
const _hoisted_1 = {
  class: "df-middle",
  style: {"line-height":"56px"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Take Profit")
const _hoisted_3 = {
  key: 0,
  class: "bg-background br-lg p-16 c-title"
}
const _hoisted_4 = { class: "df-middle" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Pips")
const _hoisted_6 = { class: "df-middle mt-8" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Est. Price")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Switch = _resolveComponent("Switch")
  const _component_TheLimitRangeInput = _resolveComponent("TheLimitRangeInput")
  const _component_RealTimeQuote = _resolveComponent("RealTimeQuote")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_t, {
        class: "flex-1 f-bold",
        path: "placeorder_15"
      }, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_Switch, {
        checked: !_ctx.noLimit,
        onChange: _ctx.toggleLimit
      }, null, 8, ["checked", "onChange"])
    ]),
    (!_ctx.noLimit)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_t, {
              class: "flex-1",
              path: "placeorder_46"
            }, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_TheLimitRangeInput, {
              min: _ctx.minPips,
              max: _ctx.maxPips,
              value: _ctx.pips,
              onChange: _cache[1] || (_cache[1] = v => _ctx.limit(v)),
              onExceed: _ctx.exceed,
              step: 10
            }, {
              default: _withId(({ value }) => [
                _createTextVNode(_toDisplayString(value), 1)
              ]),
              _: 1
            }, 8, ["min", "max", "value", "onExceed"])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_t, {
              path: "placeorder_44",
              class: "flex-1"
            }, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            (_ctx.isCommission)
              ? (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(_ctx.order.entrustPosition.value > 0 ? _ctx.calcProfitLossPrice(_ctx.estQuote, _ctx.order.entrustFinalPrice(Number(_ctx.order.type.value) === 1 ? -1 : 1).toString() ) : '--'), 1))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  (_ctx.createPrice)
                    ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(_ctx.calcProfitLossPrice(_ctx.estQuote, _ctx.createPrice)), 1))
                    : (_openBlock(), _createBlock(_component_RealTimeQuote, {
                        key: 1,
                        symbol: _ctx.symbol
                      }, {
                        default: _withId(({price, buy}) => [
                          _createTextVNode(_toDisplayString(_ctx.calcProfitLossPrice(_ctx.estQuote, price.toString())), 1)
                        ]),
                        _: 1
                      }, 8, ["symbol"]))
                ], 64))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
})